import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import user from './user';
import customer from './customer';
import product from './product';
import cart from './cart';
import tabs from './tabs';
import activeRefills from './activeRefills';
import orderParams from './orderParams';
import rxAvailable from './rxAvailable';
import address from './address';
import order from './order';
import refill from './refill';
import pastOrders from './pastOrders';
import prescriptionImages from './prescriptionImages';
import gateways from './gateways';
import action from './action';
import deliveredOrders from './deliveredOrders';
import deliveredMedicines from './deliveredMedicines';
import patients from './patients';
import diagnosticsSlots from './diagnosticsSlots';
import diagnosticsCart from './diagnosticsCart';
import diagOrder from './diagOrder';
import coupon from './coupon';
import loyalty from './loyalty';
import docConsult from './docConsult';
import servicePlatform from './servicePlatform';

import * as Constants from '../constants';

const appReducer = combineReducers({
  routing,
  user,
  customer,
  product,
  cart,
  tabs,
  activeRefills,
  orderParams,
  rxAvailable,
  address,
  order,
  refill,
  pastOrders,
  prescriptionImages,
  action,
  gateways,
  deliveredOrders,
  deliveredMedicines,
  patients,
  diagnosticsSlots,
  diagnosticsCart,
  diagOrder,
  coupon,
  loyalty,
  docConsult,
  servicePlatform,
});
const rootReducer = (state, action) => {
  let newState = { ...state };
  switch (action.type) {
    case Constants.CANCEL_ORDER:
      newState = {
        user: state.user,
        customer: {
          isActive: false,
          customerDetails: {},
          location: {}
        }
      };
      break;
    // case Constants.SET_ORDER_TYPE:
    //   newState = Object.assign({ ...state }, { state: { orderParams: { orderType: action.data } } });
    //   newState.orderParams.orderType = action.data;
    //   break;
    case Constants.AGENT_LOGOUT_SUCCESS:
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('reduxState');
      }
      newState = {};
      break;
    case Constants.AGENT_LOGOUT_FAILURE:
      newState = Object.assign(newState, { data: action.data });
      break;
    case Constants.OPEN_CMS_URL_SUBSCRIPTION:
      window.open(action.url);
      break;
    default:
  }
  return appReducer(newState, action);
};

export default rootReducer;
